import { render, staticRenderFns } from "./member_user_upgrade.vue?vue&type=template&id=5606f784"
import script from "./member_user_upgrade.vue?vue&type=script&lang=js"
export * from "./member_user_upgrade.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports